<template>
	<div class="item-card">
		<div class="item-cont-desc">
			<div class="item-cont-head">{{ head }}</div>
			<hr>
			<div class="item-cont-cont">{{ cont }}</div>
		</div>
	</div>
</template>

<script>
export default {
  props: ['idx','img','head','cont']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-card{
	color: white;
	
    display: flex;
    justify-content: center;
    
	padding: 15px;
	font-size: 15px;
}
.item-idx-cont{
    display: flex;
    align-items: center;
    font-size: 96px;
}
.item-img-cont > img{
    max-width: 240px;
}
.vr > hr{
    width:1;
    height:100%;
    margin: 0 10px;
}
.item-cont-desc{
	width: 720px;
	
	padding: 0px 5px;
	display: block;
}
.item-cont-head{
	font-size: 24px;
	text-transform: uppercase;
}
.item-cont-cont{
    text-align: justify;
	font-size: 20px;
}

@media screen and (min-width: 640px) and (max-width: 960px){
    .item-img-cont > img{
        max-width: 180px;
    }

    .item-cont-desc{
    	width: 600px;
    }
    .item-cont-head{
    	font-size: 20px;
    	text-transform: uppercase;
    }
    .item-cont-cont{
        text-align: justify;
    	font-size: 16px;
    }
}

@media screen and  (min-width: 480px) and (max-width: 640px){
    .item-card{
		display: inline-grid;
		justify-items: center;
	}
	
	.item-idx-cont{
        display: none;
    }

    .item-img-cont > img{
		max-width: 196px;   
    }
    .vr > hr{
        display: none
    }

    .item-cont-desc{
    	width: 440px;
    }
    .item-cont-head{
    	font-size: 20px;
    	text-transform: uppercase;
    }
    .item-cont-cont{
        text-align: justify;
    	font-size: 16px;
    }
}
@media screen and (max-width: 480px){
	.item-card{
		display: inline-grid;
		justify-items: center;
	}

	.item-idx-cont{
        display: none;
    }
    .item-img-cont > img{
		max-width: 240px;
        display: block;
    }
    .vr > hr{
        display: none;
    }

    .item-cont-desc{
    	width: 240px;
    }
    .item-cont-head{
    	font-size: 20px;
    	text-transform: uppercase;
    }
    .item-cont-cont{
        text-align: justify;
    	font-size: 14px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/ProcCard.vue